import * as React from "react";
import {useState} from "react";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import RadioButtons from "../../../../../ui/radiobutton/radiobutton";
import {RadioButton} from "../../../../../modals/types/radiobutton";
import Button from "../../../../../core/button/button";
import {AddElements} from "../../../../../modals/types/addelements";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";
import "./tab4.scss";

const Tab4 = () => {
    const [showers, setShowers] = useState('G');
    const [addElements, setAddElements] = useState<AddElements[]>([]);
    const [counter, setCounter] = useState(0)
    const showersRadioContent: RadioButton[] = [
        {label: "گروه نمایش دهنده ها", currentValue: "G"},
        {label: "نمایش دهنده ها", currentValue: "S"},
    ]
    const clickPriceAutoCompleteItems: DropDownItem[] = [
        {label: "50 هزار تومان"}, {label: "100 هزار تومان"}, {label: "150 هزار تومان"}, {label: "200 هزار تومان"}
    ];
    const dailyMoneyAutoCompleteItems: DropDownItem[] = [
        {label: "1 میلیون تومان"}, {label: "2 میلیون تومان"}, {label: "5 میلیون تومان"}, {label: "10 میلیون تومان"}
    ];
    const showerChooseAutoCompleteItems: DropDownItem[] = [
        {label: "ورزش 3"}, {label: "دیوار"}
    ];
    const showerClickPriceAutoCompleteItems: DropDownItem[] = [
        {label: "1 میلیون تومان"}, {label: "2 میلیون تومان"}, {label: "5 میلیون تومان"}, {label: "10 میلیون تومان"}
    ];

    const newItem = (id: number): JSX.Element => {
        return (
            <>
                <div className="col-lg-5 col-md-5 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">انتخاب نمایش دهندگان</label>
                    <DropDown items={showerChooseAutoCompleteItems} placeHolder={"مثال: ورزش ۳"}/>
                </div>
                <div className="col-lg-5 col-md-5 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">قیمت هر کلیک نمایش دهنده</label>
                    <DropDown items={showerClickPriceAutoCompleteItems} placeHolder={"مثال: ۱ میلیون تومان"}/>
                </div>
                <div className="col-lg-1 col-md-1 col-12 mb-3 d-flex align-items-end">
                    <Button type={"action-secondary"} action={() => {
                        setAddElements((prev) => {
                            return prev.filter(item => item.id !== id)
                        });
                    }} responsive={true}>
                        <img src={require("../../../../../assets/images/icons/Delete.svg").default} alt=""
                             className="img-fluid"/>
                    </Button>
                </div>
            </>
        );
    }

    const setRadioContent = (value: string): JSX.Element => {
        if (value === 'G') {
            return (
                <>
                    1
                </>
            );
        } else if (value === 'S') {
            return (
                <>
                    {
                        addElements.map((element, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {element.element}
                                </React.Fragment>
                            );
                        })
                    }
                    <div className="col-lg-5 col-md-5 col-12 mb-3">
                        <label className={"mb-2"} htmlFor="">انتخاب نمایش دهندگان</label>
                        <DropDown items={showerChooseAutoCompleteItems} placeHolder={"مثال: ورزش ۳"}/>
                    </div>
                    <div className="col-lg-5 col-md-5 col-12 mb-3">
                        <label className={"mb-2"} htmlFor="">قیمت هر کلیک نمایش دهنده</label>
                        <DropDown items={showerClickPriceAutoCompleteItems} placeHolder={"مثال: ۱ میلیون تومان"}/>
                    </div>
                    <div className="col-lg-1 col-md-1 col-12 mb-3 d-flex align-items-end">
                        <Button type={"action-primary"} action={() => {
                            const newID = counter
                            const newElement = {
                                element: newItem(newID),
                                id: newID
                            }
                            setAddElements(prev => [...prev, newElement]);
                            setCounter(prev => prev + 1)
                        }} responsive={true}>
                            <img src={require("../../../../../assets/images/icons/Add.svg").default} alt=""
                                 className="img-fluid"/>
                        </Button>
                    </div>
                </>
            );
        } else {
            return <></>
        }
    }
    return (
        <div className="Tab4">
            <div className="row mt-3">
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">هزینه هر کلیک</label>
                    <DropDown items={clickPriceAutoCompleteItems} placeHolder={"مثال: ۵۰ هزار تومان"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">بودجه روزانه</label>
                    <DropDown items={dailyMoneyAutoCompleteItems} placeHolder={"مثال: ۱ میلیون تومان"}/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>قیمت شناور نمایش دهنده ها</span>
                </div>
                <div className="col-12 mb-3">
                    <h6 className="mb-3 pt-1 font-light">نمایش دهندگان</h6>
                    <RadioButtons items={showersRadioContent} value={showers} setValue={setShowers}/>
                </div>
                {setRadioContent(showers)}
            </div>
        </div>
    );
}

export default Tab4;